import Link from "next/link";
import React, { useState } from "react";
import cx from "classnames";
import { routesURL } from "../urls";
import Video from "./Video";
import { CHAT_DEMO_2, NOTEBOOK_DEMO_1_FAST } from "@/static-urls";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoCloseOutline } from "react-icons/io5";
import WebGLCubeLogo from "../assets/logo/WebGLCubeLogo";
const HamBurger = ({ links = [] }) => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleHide = () => setShow(false);

  return (
    <div className=" max-sm:block hidden">
      <RxHamburgerMenu
        size={20}
        className=" text-white"
        onClick={handleShow}
      />
      <div
        className={cx(
          " fixed flex items-center justify-center top-0 left-0 bg-[#0F140F] z-[999] h-screen w-screen text-[#ededed] transition-transform duration-200",
          {
            " translate-x-full": !show,
            "translate-x-0": show,
          }
        )}
      >
        <ul className=" text-[2rem]">
          {links.map((link, index) => (
            <li className=" mt-3" key={index}>
              <Link
                aria-label="blockset-mobile-view-link"
                href={link.link}
                onClick={handleHide}
              >
                {link.text}
              </Link>
            </li>
          ))}
        </ul>
        <button className=" absolute top-6 right-6" onClick={handleHide}>
          <IoCloseOutline size={28} />
        </button>
      </div>
    </div>
  );
};
const NavLink = ({ link, text }) => (
  <li>
    <Link
      href={link}
      className=" h-full w-full font-inter transition-colors duration-200 hover:text-white"
      aria-label={`blockset-navigation-link-${text}`}
    >
      {text}
    </Link>
  </li>
);
const Nav = () => {
  const links = [
    {
      text: "About",
      link: routesURL.about,
    },
    {
      text: "Features",
      link: "/#features",
    },
    {
      text: "Pricing",
      link: routesURL.pricing,
    },
    {
      text: "Blog",
      link: routesURL.blog,
    },
    {
      text: "FAQ",
      link: "/#FAQ",
    },
  ];
  return (
    <>
      <nav className=" mx-auto lg:w-[850px] max-md:w-[90%] max-sm:w-[calc(100%-32px)] max-md:overflow-x-scroll no-scrollbar  flex items-center justify-between px-[20px] max-sm:px-[14px] py-[8px] rounded-[24px] max-sm:rounded-[18px] bg-[#3A4F3A] shadow-[inset_0_1px_0_rgba(255,255,255,.22),inset_0_-1px_0_rgba(255,255,255,.08),0_24px_70px_rgba(0,0,0,.34)] backdrop-blur-[34px] backdrop-saturate-200 ">
        <div className="blockset-logo-anchor flex items-center gap-x-2">
          <WebGLCubeLogo />
          <Link href={routesURL.index} aria-label="Blockset home">
            <span className="text-[24px] font-medium text-white max-sm:text-[17px]">
              Blockset
            </span>
          </Link>
        </div>
        <ul className=" flex items-center justify-between text-[#d6d6d6] gap-x-[40px] text-[13px] max-sm:hidden">
          {links.map((item, index) => (
            <NavLink key={index} text={item.text} link={item.link} />
          ))}
        </ul>

        <div className=" flex items-center justify-center gap-x-4">
          <Link href={routesURL.login} target="__blank" className="max-[360px]:hidden">
            <button className="flex h-[32px] w-[68px] items-center justify-center rounded-[14px] bg-[rgba(18,18,18,.42)] font-inter text-[12px] font-semibold text-white shadow-[inset_0_1px_0_rgba(255,255,255,.16),0_8px_18px_rgba(0,0,0,.18)] backdrop-blur-xl transition-[background-color,box-shadow,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[rgba(18,18,18,.52)] hover:shadow-md active:translate-y-0 active:scale-[0.98] max-sm:h-[28px] max-sm:w-[58px] max-sm:text-[11px]">
              Log in
            </button>
          </Link>
          <Link href={routesURL.signup} target="__blank">
            <button className="flex h-[32px] w-[78px] items-center justify-center rounded-[14px] bg-[rgba(18,18,18,.42)] font-inter text-[12px] font-semibold text-white shadow-[inset_0_1px_0_rgba(255,255,255,.16),0_8px_18px_rgba(0,0,0,.18)] backdrop-blur-xl transition-[background-color,box-shadow,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[rgba(18,18,18,.52)] hover:shadow-md active:translate-y-0 active:scale-[0.98] max-sm:h-[28px] max-sm:w-[66px] max-sm:text-[11px]">
              Sign up
            </button>
          </Link>
          <HamBurger links={links} />
        </div>
      </nav>
    </>
  );
};
const Pattern = () => (
  <div className=" max-sm:hidden absolute w-full h-[100%] left-1/3 top-[50px] square-pattern bg-[#0F140F]" />
);
const Hero = () => {
  return (
    <div className=" min-h-[calc(100svh-86px)] max-sm:min-h-0 relative overflow-x-hidden overflow-y-hidden max-sm:overflow-visible">
      <Pattern />
      <div className=" flex max-sm:flex-col items-center justify-center min-h-[inherit] relative z-50 px-32 max-sm:px-6 py-10 max-sm:pb-14 gap-x-[60px]">
        <div className=" basis-[40%] relative max-sm:basis-auto max-sm:w-full">
          <h1 className="text-[36px] leading-tight max-sm:text-[28px] font-medium text-[#EDEDED] max-sm:text-center">
            Serverless Data Analytics built on DuckDB
            <br />
            {/* Data Analytics */}
          </h1>
          <p className=" text-[#A9A9A9] mt-7 font-inter text-[14px] leading-relaxed max-sm:text-[15px] max-sm:text-center max-sm:mx-auto max-sm:max-w-[34rem]">
            Blockset is a high performance serverless data platform that
            enables you to manage and analyse your data in an easy to use,
            blazing fast and AI powered way.
          </p>
          <p className=" text-[#EDEDED] mt-7 font-inter text-[13px] leading-relaxed max-sm:text-[14px] font-semibold max-sm:text-center max-sm:mx-auto max-sm:max-w-[32rem]">
            No infra setup, No complex data pipelines, No expensive cloud bills
          </p>
          <Link href={routesURL.login} target="__blank" className=" ">
            <button className="mt-[40px] block rounded-[10px] bg-white px-[20px] py-[8px] font-inter text-[13px] font-semibold antialiased shadow-[0_12px_30px_rgba(255,255,255,.12)] transition-[background-color,box-shadow,transform] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[#f7f7f7] hover:shadow-[0_16px_35px_rgba(255,255,255,.18)] active:translate-y-0 active:scale-[0.98] max-sm:mx-auto">
              30-Day FREE Trial
            </button>
          </Link>
        </div>
        <div className=" basis-[70%] max-sm:basis-full max-sm:w-full max-sm:self-center max-sm:mt-[46px]">
          <Video
            srcs={[CHAT_DEMO_2, NOTEBOOK_DEMO_1_FAST]}
            paginationButtons={["Chat", "Notebook"]}
          />
        </div>
      </div>
    </div>
  );
};
const Header = ({ children, showHero = true }) => {
  return (
    <React.Fragment>
      <header
        className={cx(" bg-[#0F140F] pt-[30px] font-geoGraph", {
          "min-h-screen max-sm:min-h-0": showHero,
        })}
      >
        <Nav />
        {showHero && <Hero />}
      </header>
      {children}
    </React.Fragment>
  );
};

export default Header;
